module.exports = __webpack_public_path__ + "img/1.df28966b.png";